import InnerBanner from "../Components/InnerBanner/InnerBanner";
import MultiContent from "../Components/MultiContent/MultiContent";

function Onsite() {
    return (
        <>
            <InnerBanner
                img_url='onsiteBanner.webp'
                heading={['On-Site Learning That', <br/>, 'Improves Your DevOps Skills']}
            />
            <MultiContent
                left_img
                bottomHeading
                heading="Why Opt for On-Site Courses?"
                descClass='med'
                description={[
                    "Experience the power of in-person learning with Skill Bridge's on-site courses. We recognise that while online education offers flexibility, there's no substitute for the immersive and interactive experience of face-to-face training. Our on-site courses provide you with a dynamic environment to deepen your DevOps expertise and practical skills."
                ]}
                img_url='onsite1.webp'
                accordion={[
                    {
                        'head': 'Immersive Learning',
                        'content': "On-site courses immerse you in a dedicated learning environment, free from distractions.\n" +
                            "This focused setting enhances your ability to grasp complex DevOps concepts."
                    },
                    {
                        'head': 'Real-Time Interaction',
                        'content': 'Engage directly with instructors and peers. Ask questions, share experiences, and benefit\n' +
                            'from immediate feedback. The personal touch fosters a supportive and collaborative\n' +
                            'atmosphere.'
                    },
                    {
                        'head': 'Hands-On Practice',
                        'content': 'DevOps is all about hands-on work, and our on-site courses mirror this principle. You\'ll have\n' +
                            'access to labs, simulations, and real-world scenarios, enabling you to apply what you learn\n' +
                            'immediately.'
                    },
                    {
                        'head': 'Networking Opportunities',
                        'content': 'Forge valuable connections within the DevOps community. Connect with like-minded\n' +
                            'professionals and industry experts to expand your network and open doors to new\n' +
                            'opportunities.\n'
                    }
                ]}
            />
            <MultiContent
                right_img
                class="coloured"
                topHeading
                heading="Upcoming Dates and Easy Registration"
                description={[
                    "Enrolling in our on-site courses is straightforward. Explore our course calendar to discover\n" +
                    "upcoming dates that align with your schedule, then follow these steps:"
                ]}
                img_url='onsite2.webp'
                accordion={[
                    {
                        'head': 'Choose Your Course',
                        'content': 'Explore our diverse range of on-site offerings and select the one that aligns with your career\n' +
                            'objectives.'
                    },
                    {
                        'head': 'Register',
                        'content': 'Click the "Register" button on the course page and follow a simple registration process.'
                    },
                    {
                        'head': 'Secure Payments',
                        'content': "We offer secure payment options to complete your registration. Once payment is confirmed,\n" +
                            "you'll receive all the necessary details to attend your selected course."
                    },
                    {
                        'head': 'Commence Your Journey',
                        'content': "On your course start date, you'll join us at our on-site location, ready to embark on a\n" +
                            "transformative DevOps journey."
                    },
                ]}
            />
            <MultiContent
                right_img
                tag="how we work"
                topHeading
                heading="Transform Your DevOps Career On-Site"
                description={[
                    "Skill Bridge's on-site courses are your gateway to elevating your DevOps skills in a dynamic and engaging environment. We believe in the power of face-to-face learning, where personal interactions and practical experience drive your success.",
                    "Don't miss this opportunity to take your DevOps skills to the next level. Explore our upcoming on-site courses, register today, and experience the difference of in-person learning. Your path to DevOps excellence begins here, and we can't wait to welcome you on-site.",
                ]}
                img_url='program5.webp'
            />
        </>
    )
}

export default Onsite